var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "24px",
    height: "24px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 13.816,
    style: {
      fill: "#F2B851"
    },
    width: 128.16,
    height: 493.696
  }), /*#__PURE__*/React.createElement("rect", {
    y: 142.008,
    style: {
      fill: "#1A1718"
    },
    width: 128.16,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.224,
    y: 13.816,
    style: {
      fill: "#32BEA6"
    },
    width: 128.16,
    height: 493.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.24,
    y: 142.008,
    style: {
      fill: "#1A1718"
    },
    width: 128.16,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E04F5F"
    },
    points: "512,496.232 384.32,507.496 340.16,15.752 467.856,4.488 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.947,
    y: 89.706,
    transform: "matrix(-0.0879 -0.9961 0.9961 -0.0879 300.4084 582.6343)",
    style: {
      fill: "#1A1718"
    },
    width: 31.999,
    height: 128.156
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.c871881c89bc203a22db0092856f32e2.svg";
export { ForwardRef as ReactComponent };